import React, { memo } from "react";
import { HStack, Text, Highlight, Stack } from "@chakra-ui/react";
import colors from "app/colors";
import { getUserFullName, getUserMention } from "modules/utils/Functions";
import { InternalAdminUserFragment } from "gql/graphql";
import InternalAdminUserAvatar from "../components/internal-admin-user-avatar";

interface IProps {
  user?: InternalAdminUserFragment;
  search: string;
}

const InternalAdminUserOptionLabel = ({ user, search }: IProps) => {
  if (!user) return null;

  if (user.active) {
    return (
      <HStack color={colors.blue} spacing={2} h="32px">
        <InternalAdminUserAvatar
          avatarUrl={user.avatarUrl}
          active={user.active}
          firstName={user.firstName}
          lastName={user.lastName}
          roleType={user.roleType}
          size="sm"
        />
        <Stack spacing={0} alignItems="flex-start">
          <HStack spacing={1}>
            <Text noOfLines={1} fontSize={12}>
              <Highlight
                query={search}
                styles={{
                  fontWeight: 700,
                  color: colors.blue,
                  margin: "0 !important",
                }}
              >
                {getUserMention(user)}
              </Highlight>
            </Text>
          </HStack>
          <Text noOfLines={1} fontSize={12} color={colors.gray50}>
            <Highlight
              query={search}
              styles={{
                fontWeight: 700,
                color: colors.gray50,
                margin: "0 !important",
              }}
            >
              {getUserFullName(user)}
            </Highlight>
          </Text>
        </Stack>
      </HStack>
    );
  }

  return (
    <HStack color={colors.grayMain} spacing={2} h="32px">
      <InternalAdminUserAvatar
        avatarUrl={user.avatarUrl}
        active={user.active}
        firstName={user.firstName}
        lastName={user.lastName}
        roleType={user.roleType}
        size="2xs"
      />
      <Text noOfLines={1} fontSize={12}>
        <Highlight
          query={search}
          styles={{
            fontWeight: 700,
            color: colors.blue,
            margin: "0 !important",
          }}
        >
          {getUserMention(user)}
        </Highlight>
      </Text>
    </HStack>
  );
};

export default memo(InternalAdminUserOptionLabel);
